module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j3AZw"))).then(() => parcelRequire('iDabs'));